export interface ILabels {
  _id: string
  color: string
  description?: string
  title: string
}

export enum TagsFiltersEnum {
  SEARCH_TERMS_TAGS_FILTERS = "searchTermsTagsFilters",
  CATEGORIES_TAGS_FILTERS = "categoriesTagsFilters",
}

export enum StateFiltersEnum {
  STATE_FILTER = "stateFilter",
}
